import { render } from "./JEntryTemplete.vue?vue&type=template&id=87a8434c&scoped=true"
import script from "./JEntryTemplete.vue?vue&type=script&lang=js"
export * from "./JEntryTemplete.vue?vue&type=script&lang=js"

import "./JEntryTemplete.vue?vue&type=style&index=0&id=87a8434c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a8434c"]])

export default __exports__